import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { Paper, Pagination } from 'virtues-bootstrap';

import s from './styles.module.scss';

const PaginationSection = ({ activePage, itemsPerPage, textKey, total, t, ...rest }) => {
  const toValue = (activePage + 1) * itemsPerPage;
  const to = toValue > total ? total : toValue;

  return (
    <Paper className={s.paginationSection}>
      <div className={s.text}>
        {t(textKey, {
          from: activePage * itemsPerPage + 1,
          to,
          total,
        })}
      </div>
      {total > itemsPerPage && (
        <Pagination
          initialPage={activePage}
          marginPagesDisplayed={2}
          pageRangeDisplayed={3}
          pageCount={Math.ceil(total / itemsPerPage)}
          t={t}
          {...rest}
        />
      )}
    </Paper>
  );
};

PaginationSection.defaultProps = {
  itemsPerPage: 10,
};

PaginationSection.propTypes = {
  /** Index of active page */
  activePage: PropTypes.number.isRequired,
  /** How many item will be displayed on page */
  itemsPerPage: PropTypes.number,
  /** Callback when page changed */
  onPageChange: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
  textKey: PropTypes.string.isRequired,
  /** Total items in list */
  total: PropTypes.number.isRequired,
};

export default withTranslation()(PaginationSection);
